import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const UploadFailureBanner = ({
  pendingCount,
  quotaExceeded,
  retryLoading,
  onRetry
}) => (
  <div className="upload-failure-banner" role="alert">
    <div className="upload-failure-banner-text">
      <strong>Segment upload failed</strong>
      <p>
        Recording continues.
        {pendingCount > 0
          ? ` ${pendingCount} segment${pendingCount === 1 ? '' : 's'} waiting to upload.`
          : ''}
        {' '}You can retry now or upload when you stop.
        {quotaExceeded
          ? ' Browser storage is full — a page refresh may lose pending audio until uploads succeed.'
          : ''}
      </p>
    </div>
    <div className="upload-failure-banner-actions">
      <button
        type="button"
        className="header-button header-button-primary"
        onClick={onRetry}
        disabled={retryLoading || pendingCount === 0}
      >
        {retryLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Retry now'}
      </button>
    </div>
  </div>
);

export default UploadFailureBanner;
